var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "temp-copy-right" } }, [
      _c("div", [
        _c("a", { attrs: { href: "https://pahomov.pro" } }, [
          _vm._v("©2020 pahomov.pro")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }